export default 'M19.07 1a2.36 2.36 0 1 1 0 4.71H9.05L22.3 18.98a2.36 2.36 0 0 1-3.33 3.33L5.7 9.05v10.02a2.36 2.36 0 1 1-4.71 0V1z';